import { createApp } from 'vue';
import { createI18n } from 'vue-i18n';
import App from './components/App.vue';
import { DragonDropVue } from 'dragon-drop-vue';

const dragonDropOptions = {
  dragOverDebounceMs: 5000,
  debugLog: false,
  containment: 'parent'
}

// Translations
import nl from './locales/nl.json';
import en from './locales/en.json';
import de from './locales/de.json';

const translations = {
	nl: nl,
	en: en,
	de: de
}

const userLocale = typeof current_language !== 'undefined' ? current_language : 'en';

const i18n = createI18n({
	legacy: false,
	locale: userLocale,
	useScope: 'global',
	globalInjection: true,
	fallbackLocale: 'en',
	messages: translations
});
  
const app = createApp( App );

if( document.querySelector( '#app' ) ) {

	app.use(i18n);
	app.use(DragonDropVue, dragonDropOptions);
	app.mount( '#app' );

}